module.exports = __webpack_public_path__ + "assets-cabinet/img/transactions.3e163deb.svg";